import { render, staticRenderFns } from "./mainCenter2.vue?vue&type=template&id=0326170e&scoped=true&"
import script from "./mainCenter2.vue?vue&type=script&lang=js&"
export * from "./mainCenter2.vue?vue&type=script&lang=js&"
import style0 from "./mainCenter2.vue?vue&type=style&index=0&id=0326170e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0326170e",
  null
  
)

export default component.exports